module.exports = __webpack_public_path__ + "img/IconCM.0b1884aa.svg";